import { useState } from "react";
import { Card, Collapse, Dropdown } from "react-bootstrap";
import {
  FiMoreVertical,
  FiChevronDown,
  FiPlus,
  FiStar,
} from "react-icons/fi";
import AddTaskModal from "../../modals/projects/AddTaskModal";
import ViewTaskModal from "../../modals/projects/ViewTaskModal";


const TasksSection = () => {
  const [open, setOpen] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [showView, setShowView] = useState(false);

  const tasks = [
    {
      title: "Patient appointment booking",
      status: "Onhold",
    },
    {
      title: "Appointment booking with payment gateway",
      status: "Inprogress",
    },
    {
      title: "Patient and Doctor video conferencing",
      status: "Completed",
    },
  ];

  return (
    <>
      <Card className="custom-card mb-3">
        <Card.Body>

          {/* HEADER */}
          <div className="task-header">
            <h6>Tasks</h6>

            <FiChevronDown
              className={`accordion-icon ${open ? "rotate" : ""}`}
              onClick={() => setOpen(!open)}
            />
          </div>

          {/* CONTENT */}
          <Collapse in={open}>
            <div>

              {tasks.map((task, i) => (
                <div key={i} className="task-row">

                  {/* LEFT */}
                  <div className="task-left">
                    <span className="drag">⋮⋮</span>
                    <input type="checkbox" />
                    <FiStar className="star" />
                    <span className="task-title">{task.title}</span>
                  </div>

                  {/* RIGHT */}
                  <div className="task-right">

                    <span className={`status ${task.status.toLowerCase()}`}>
                      {task.status}
                    </span>

                    <div className="avatars">
                      <img src="/assets/img/profiles/avatar-02-1.jpg" />
                      <img src="/assets/img/profiles/avatar-03.jpg" />
                    </div>

                    {/* DROPDOWN */}
                    <Dropdown align="end">
                      <Dropdown.Toggle className="menu-btn text-dark">
                        <FiMoreVertical />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="task-menu">
                        <Dropdown.Item onClick={() => setShowAdd(true)}>
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item>
                          Delete
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowView(true)}>
                          View
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                  </div>
                </div>
              ))}

              {/* ADD TASK */}
              <div
                className="add-task"
                onClick={() => setShowAdd(true)}
              >
                <FiPlus /> New task
              </div>

            </div>
          </Collapse>
        </Card.Body>
        <style>
          {
               `
               .custom-card{
               border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
               }
               .task-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accordion-icon {
  cursor: pointer;
  transition: 0.3s;
}

.accordion-icon.rotate {
  transform: rotate(180deg);
}

/* TASK ROW */
.task-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 6px;
  margin-top: 10px;
}

.task-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.task-title {
  font-size: 14px;
}

/* RIGHT */
.task-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* STATUS */
.status {
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 12px;
}

.status.onhold { background: #fde2e2; color: #e11d48; }
.status.inprogress { background: #ede9fe; color: #7c3aed; }
.status.completed { background: #dcfce7; color: #16a34a; }

/* AVATAR */
.avatars img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-left: -6px;
  border: 2px solid #fff;
}

/* MENU */
.menu-btn {
  background: transparent !important;
  border: none !important;
}

/* ADD TASK */
.add-task {
  border: 1px dashed #f97316;
  padding: 10px;
  margin-top: 10px;
  cursor: pointer;
  color: #f97316;
}

/* BUTTON */
.btn-orange {
  background: #f97316;
  border: none;
}

/* TAGS */
.tag {
  padding: 4px 8px;
  border-radius: 6px;
  margin-right: 5px;
}

.tag.red { background: #ef4444; color: #fff; }
.tag.green { background: #22c55e; color: #fff; }
.tag.dark { background: #1f2937; color: #fff; }`
          }
        </style>
      </Card>

      {/* MODALS */}
      <AddTaskModal show={showAdd} handleClose={() => setShowAdd(false)} />
      <ViewTaskModal show={showView} handleClose={() => setShowView(false)} />
    </>
  );
};

export default TasksSection;